import * as React from "react";
import styled from "styled-components";
import LeftMenu from "./LeftMenu";
import { CloseOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Menu, Dropdown,Button } from "antd";

import { usePage } from "@/component/PageControl";

import AboutModal from "./aboutModal";
import ContactModal from "./contact";
import { useAuth } from "@/component/Auth";
import { storage } from "@/util";
import { LOGININFOSTORE, LOGINTOKEN, APKNAME, RECORD_SERVER } from "@/config/const";
import isElectron from "is-electron";
import { Link, useHistory } from "react-router-dom";

const SmallFrame = styled.div`
  width: 1050px;
  height: 562px;
  display: flex;
  border-radius: 16px;
  background: var(--Almost-white, #FAFAFA);
  box-shadow: 0px 0px 12px 0px rgba(17, 17, 19, 0.04);
  .aclose {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 14px;
    height: 14px;
  }
`;

const MainContentDiv = styled.div<{
  pt: string;
  children?: any;
  [k: string]: any;
}>`
  flex: 1;
  display: flex;
  position: relative;
  justify-content: center;
  border-radius: 16px;
  place-items: center;
  ${(p) => (p.pt === "setting" ? "position: relative" : "")}
  .abouticon {
    position: absolute;
    right: 10px;
    top: 8px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .modal {
    position: absolute;
    right: 0;
    top: 0;
    width: 632px;
    height: 562px;
    background: white;
    z-index: 99;
  }
  background: '#FAFAFA'
`;

const MainContent: React.FC<{ children?: any; [k: string]: any }> = (p) => {
  const history = useHistory();
  const page = usePage();
  const { pagetype, leaveSetting } = page;
  const auth = useAuth();
  const [showAbout, setShowAbout] = React.useState(false);
  const [showContact, setShowContact] = React.useState(false);
  const { loggedIn } = auth;

  const gotoMyRecords = ()=>{
     
     //
    const accessToken = storage.get(LOGINTOKEN);
    // const w=window.open(loggedIn?RECORD_SERVER:RECORD_SERVER);
    const username = auth.loginfo.username; // 替换为你的用户名
 
    const url = loggedIn ? `${RECORD_SERVER}#/autologin/username=${username}/token=${accessToken}` : RECORD_SERVER;
    console.log("gotoMyRecords url::"+url)
    const w = window.open(url);
  };

  const exitlogin = () => {
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if (isElectron()) {
      alert(`Нэвтрэх хуудас руу чиглүүлж байна`);
      history.replace("/");
    } else {
      window.location.href = "/";
    }
  };

  const menu = (
    <Menu>
      {/* {loggedIn && (
        <Menu.Item onClick={gotoMyRecords} key="aaa0">
          <span>我的录制</span>
        </Menu.Item>
      )} */}
      <Menu.Item onClick={() => setShowAbout(true)} key="aaa1">
        <span>Бидний тухай</span>
      </Menu.Item>
      {/* <Menu.Item onClick={() => setShowContact(true)} key="aaa2">
        <span>Холбоо барих</span>
      </Menu.Item> */}
      {/* <Menu.Item key="aaa4">
        <span> <a
            href={`http://${window.location.hostname}:8012/latest/${APKNAME}`}
            target="_blank"
            rel="noreferrer"
          >
            安卓下载
          </a></span>
      </Menu.Item> */}
      {loggedIn && (
        <Menu.Item onClick={exitlogin} key="aaa3">
          <span>Гарах</span>
        </Menu.Item>
      )}
    </Menu>
  );

  if (pagetype !== "setting" && pagetype !== "main") return <></>;

  return (
    <MainContentDiv pt={pagetype} className="maincontent">
      
      {p.children}
      {pagetype === "setting" ? (
        <div className="aclose">
          <CloseOutlined onClick={leaveSetting} />
        </div>
      ) : (
        <div className="abouticon mt10 mr10">
         
          <Dropdown overlay={menu} placement="bottomRight" arrow>
            <UnorderedListOutlined style={{ fontSize: 20 }} />
          </Dropdown>
        </div>
      )}
      <AboutModal visible={showAbout} afterClose={() => setShowAbout(false)} />
      <ContactModal
        visible={showContact}
        afterClose={() => setShowContact(false)}
      />
    </MainContentDiv>
  );
};

const SmallLayout: React.FC<{ children?: any; [k: string]: any }> = (p) => {
  return (
    <SmallFrame>
      <LeftMenu />
      <MainContent>{p.children}</MainContent>
    </SmallFrame>
  );
};

export default SmallLayout;
